module.exports = __webpack_public_path__ + "static/media/title.6379fcc4.jpg";